import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoNotion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 130 48"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#Logo_Notion_svg__a)"
    >
      <path d="M45.55 34.774V20.22h.26l10.594 14.555h3.334V13.4h-3.704V27.92h-.26L45.18 13.4h-3.334v21.374zm24.672.33c4.89 0 7.89-3.153 7.89-8.432 0-5.243-3-8.432-7.89-8.432-4.853 0-7.89 3.19-7.89 8.432.037 5.28 3 8.432 7.89 8.432m0-3.08c-2.593 0-4.075-1.942-4.075-5.352 0-3.373 1.482-5.353 4.075-5.353s4.075 1.98 4.075 5.353c0 3.41-1.482 5.353-4.075 5.353M81.484 14.61v4.07H78.89v2.933h2.594v8.835c0 3.153 1.481 4.4 5.26 4.4.704 0 1.407-.074 1.963-.184v-2.86c-.444.037-.74.074-1.26.074-1.555 0-2.259-.697-2.259-2.31v-7.955h3.52V18.68h-3.52v-4.07zm9.446 20.164h3.704V18.57H90.93zm1.852-18.88c1.222 0 2.223-.99 2.223-2.2 0-1.247-1-2.237-2.223-2.237s-2.223.99-2.223 2.236c0 1.21 1 2.2 2.223 2.2m12.002 19.21c4.89 0 7.891-3.153 7.891-8.432 0-5.243-3.001-8.432-7.891-8.432-4.852 0-7.89 3.19-7.89 8.432 0 5.28 2.963 8.432 7.89 8.432m0-3.08c-2.593 0-4.074-1.942-4.074-5.352 0-3.373 1.481-5.353 4.074-5.353 2.556 0 4.075 1.98 4.075 5.353-.037 3.41-1.519 5.353-4.075 5.353m10.076 2.75h3.705v-9.422c0-2.383 1.408-3.886 3.593-3.886 2.26 0 3.297 1.246 3.297 3.703v9.605h3.705V24.29c0-3.886-2.001-6.05-5.631-6.05-2.445 0-4.075 1.1-4.853 2.934h-.259V18.57h-3.594c.037 0 .037 16.204.037 16.204" />
      <path
        fillRule="evenodd"
        d="M6.327 12.032c1.078.87 1.468.801 3.487.664L28.83 11.55c.413 0 .069-.412-.069-.457l-3.165-2.266c-.597-.458-1.423-1.008-2.96-.87L4.24 9.308c-.665.069-.802.412-.527.664zm1.147 4.418v19.96c0 1.075.528 1.464 1.743 1.396l20.899-1.213c1.216-.07 1.353-.802 1.353-1.672V15.1c0-.87-.344-1.35-1.078-1.281L8.552 15.099c-.803.069-1.078.481-1.078 1.35m20.623 1.076c.138.595 0 1.213-.596 1.281l-1.01.206v14.741c-.872.458-1.674.733-2.363.733-1.078 0-1.353-.344-2.156-1.35l-6.584-10.324v9.98l2.088.458s0 1.213-1.675 1.213l-4.634.274c-.137-.274 0-.938.46-1.075l1.215-.344V20.135l-1.675-.137c-.137-.596.207-1.465 1.147-1.534l4.978-.343 6.86 10.437v-9.224l-1.744-.206c-.138-.733.413-1.282 1.078-1.35zM2.702 7.477l19.155-1.396c2.34-.206 2.96-.069 4.428 1.007l6.102 4.28c1.01.733 1.353.939 1.353 1.74v23.507c0 1.465-.527 2.335-2.408 2.472l-22.23 1.35c-1.422.07-2.087-.136-2.82-1.075l-4.52-5.837C.959 32.45.615 31.648.615 30.71V9.812c0-1.213.55-2.198 2.087-2.335"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Logo_Notion_svg__a">
        <path
          fill="#fff"
          d="M.615 0h129v48h-129z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoNotion;
